var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropPercentageChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272.3 289.4",
    style: {
      enableBackground: "new 0 0 272.3 289.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t.svg_title {\n\t  font-size: 18px;\n\t  color:#333;\n\t}\n\n\t.svg_title_s {\n\t  font-size: 18px;\n\t}\n\n\t.svg_title, .svg_title_s, .svg_text_s {\n\t  letter-spacing: 0.1em;\n\t}\n\n\t.svg_title,.svg_title_s, .svg_text_s {\n\t  font-family: 'Noto Sans TC', 'Source Han Sans TC';\n\t  font-weight: 500;\n\t}\n\n\t.svg_level1 {\n\t  fill: #fff;\n\t}\n\n\t.svg_level2 {\n\t  fill: #c7e8f0;\n\t}\n\n\t.svg_level3 {\n\t  fill: #74cde8;\n\t}\n\n\t.svg_level4 {\n\t  fill: #4ca7e0;\n\t}\n\n\t.svg_level5 {\n\t  fill: #0478bf;\n\t}\n\t.svg_level5 .svg_text_b { color:#ffffff;}\n\n\n\t.svg_text_s {\n\t  font-size: 9px;\n\t}\n\n\t.svg_text_b {\n\t  font-size: 16px;\n\t  text-align:center;\n\t}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("text", {
    className: "svg_title",
    transform: "translate(68 15.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    id: "svg_title"
  })), /*#__PURE__*/React.createElement("text", {
    className: "svg_title_s",
    transform: "translate(48 15.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    id: "svg_title1"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20,
    id: "svg_title2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "74.4,58.8 74.4,58.8 76.1,58.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.9,58.8 196.2,58.4 197.9,58.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_area1",
    d: "M136.1,286.2L0.6,151.3c4.8-20.1,14-38.5,26.5-54.2L136.1,286.2L136.1,286.2L136.1,286.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area2",
    d: "M136.1,286.2L27.1,97.2C40,81,56.4,67.8,75.2,58.6L136.1,286.2L136.1,286.2L136.1,286.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area3",
    d: "M136.1,44.7v241.6L75.2,58.6C93.6,49.7,114.3,44.7,136.1,44.7L136.1,44.7L136.1,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area4",
    d: "M197.1,58.6l-60.9,227.6V44.7C158,44.7,178.7,49.7,197.1,58.6L197.1,58.6L197.1,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area5",
    d: "M245.1,97.2l-109,189.1l60.9-227.6C215.8,67.8,232.2,81,245.1,97.2L245.1,97.2L245.1,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area6",
    d: "M271.7,151.3L136.2,286.2l109-189.1C257.7,112.8,266.8,131.2,271.7,151.3L271.7,151.3L271.7,151.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 54.6,
    transform: "matrix(0.966 -0.2585 0.2585 0.966 -40.9767 33.1762)",
    width: 1.1,
    height: 235.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.6,
    y: 44.7,
    width: 1.1,
    height: 241.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 82.4,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -84.7877 66.3412)",
    width: 1.1,
    height: 218.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 171.8,
    transform: "matrix(0.2583 -0.9661 0.9661 0.2583 -42.996 288.8195)",
    width: 235.6,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 191,
    transform: "matrix(0.4995 -0.8663 0.8663 0.4995 -70.5439 261.0875)",
    width: 218.5,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,287l-0.4-0.4L0,151.5l0.1-0.3c4.8-20,13.8-38.3,26.6-54.4c13-16.2,29.7-29.6,48.3-38.7 c19.1-9.3,39.7-14,61.2-14s42,4.7,61.2,14c18.6,9.1,35.3,22.4,48.3,38.7l0,0c12.9,16.1,21.8,34.4,26.6,54.4l0.1,0.3l-0.2,0.2 L136.1,287L136.1,287L136.1,287z M1.2,151.2l134.9,134.3L271,151.2c-4.8-19.7-13.6-37.7-26.3-53.7l0,0 c-12.9-16.1-29.4-29.4-47.9-38.4c-19-9.2-39.4-13.9-60.7-13.9s-41.7,4.7-60.7,13.9c-18.5,9-35,22.3-47.9,38.4 C14.9,113.4,6,131.5,1.2,151.2L1.2,151.2L1.2,151.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_area7",
    d: "M136.1,285.8l-90.6-90.1c5.4-17.2,13.2-31,23.6-41.4L136.1,285.8L136.1,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area8",
    d: "M136.1,285.8l-67-131.5c11.3-11.3,25.5-18.7,42.7-22.1L136.1,285.8L136.1,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area9",
    d: "M160.5,132.1l-24.3,153.6l-24.3-153.6c7.5-1.5,15.6-2.3,24.3-2.3S152.9,130.6,160.5,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area10",
    d: "M203.1,154.2l-66.9,131.5l24.3-153.6C177.6,135.6,191.8,142.9,203.1,154.2L203.1,154.2L203.1,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_area11",
    d: "M226.8,195.7l-90.6,90.1l66.9-131.5C213.5,164.7,221.4,178.5,226.8,195.7L226.8,195.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.1,287L44.5,196l0.2-0.5c13.7-44.1,44.5-66.4,91.5-66.4s77.7,22.4,91.5,66.4l0.2,0.5L136.1,287L136.1,287 L136.1,287z M46.5,195.5l89.6,89.1l89.6-89.1c-6.8-21.4-17.7-37.7-32.4-48.4c-14.9-10.8-34.1-16.3-57.2-16.3S93.8,136.2,79,147 C64.2,157.7,53.3,174,46.5,195.5L46.5,195.5L46.5,195.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.3,285.6 159.5,132.2 161.3,132.5 137,285.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.4,285.4 202.3,153.8 203.9,154.6 136.9,286.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111,132.5 112.7,132.2 137,285.7 135.2,285.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,154.6 69.9,153.8 136.9,285.4 135.3,286.2  "
  }))), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 15.6101 144.6848)",
    id: "svg_area1_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 49.8993 100.6212)",
    id: "svg_area2_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 97.46 73.19)",
    id: "svg_area3_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 150.63 73.19)",
    id: "svg_area4_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 205.8898 100.6213)",
    id: "svg_area5_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 239.6265 144.6848)",
    id: "svg_area6_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 56.9567 196.3454)",
    id: "svg_area7_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 88.5353 163.8185)",
    id: "svg_area8_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 127.7516 150.9998)",
    id: "svg_area9_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 169.4477 165.5602)",
    id: "svg_area10_text"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg_text_b",
    transform: "matrix(1 0 0 1 199.3461 196.3456)",
    id: "svg_area11_text"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPercentageChart);
export default __webpack_public_path__ + "static/media/drop_percentage_chart.835370656ccc690c714866225b30bc50.svg";
export { ForwardRef as ReactComponent };